module.exports = __webpack_public_path__ + "static/media/kingOfCapot-3.1a2a48ac.png";